'use client';

import { useSearchParams } from 'next/navigation';

import { Pagination } from '../../pagination/pagination';

export default function SearchResultsPaginationClient({ vehiclesMeta }: any) {
  const searchParams = useSearchParams();
  const clientVehiclesMeta = {
    ...vehiclesMeta,
    page: searchParams.get('page') || 1,
  };

  return (vehiclesMeta?.filterCount as number) > vehiclesMeta.pageSize ? (
    <Pagination
      itemsMeta={clientVehiclesMeta}
      pageSize={vehiclesMeta.pageSize}
    />
  ) : null;
}
